import { render, staticRenderFns } from "./ClientEventHandler.vue?vue&type=template&id=bb716228&scoped=true&"
import script from "./ClientEventHandler.vue?vue&type=script&lang=js&"
export * from "./ClientEventHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb716228",
  null
  
)

export default component.exports